import { render, staticRenderFns } from "./ThgQuoteWorkitemImageCard.vue?vue&type=template&id=0abca612&"
import script from "./ThgQuoteWorkitemImageCard.vue?vue&type=script&lang=ts&"
export * from "./ThgQuoteWorkitemImageCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VSelect,VSpacer})
